import { InjectionToken } from '@angular/core';

export interface ConsentManagementTranslations {
  privacyPolicyUrl: string;
}

export const CONSENT_MANAGEMENT_TRANSLATIONS = new InjectionToken<ConsentManagementTranslations>(
  'shared.util-core.ConsentManagementTranslations'
);

// as related service doesn't have a public interface, type is defined with `unknown`
export const CONSENT_MANAGEMENT_SERVICE = new InjectionToken<unknown>('shared.util-core.ConsentManagementService');

export const FT_HDMS_DIDOMI_COOKIE_CONSENT = 'ldt_hdms_didomi_cookieconsent';
